import type { ResponsiveValue } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";

import {
	Logo,
	Tagline,
} from "../../newui/features/Auth/components/Login/styled";
import logo from "./../../icons/logo-text.svg";
import tagline from "./../../icons/tagline.svg";

interface LogoWrapperProps {
	heightPixels?: number;
	marginBottom?: ResponsiveValue<string | number>;
}

export const LogoWrapper: React.FC<LogoWrapperProps> = ({
	marginBottom = "140px",
	heightPixels = 36,
}) => {
	return (
		<Box marginBottom={marginBottom}>
			<a
				href="/"
				className="flex"
			>
				<Logo
					src={logo}
					alt="Procuracon Logo"
					style={{
						height: `${heightPixels ?? 36}px`,
						maxWidth: heightPixels ? "90%" : "160px",
					}}
				/>
				<Tagline
					src={tagline}
					alt="Build Possible"
					style={{ height: `${(heightPixels ?? 36) - 2}px` }}
				/>
			</a>
		</Box>
	);
};
